export const TEXT_OVERLAY = {
LABEL_TEXT:{key: 'LABEL_TEXT', value: 'Text'},
LABEL_COLOR:{key: 'LABEL_COLOR',value: 'Color'},
LABEL_FONT_FAMILY:{key: 'LABEL_FONT_FAMILY', value: 'Font Family'},
LABEL_FONT_SIZE:{key: 'LABEL_FONT_SIZE', value: 'Font Size'},
DRAG_AND_DROP_INFO:{key: 'DRAG_AND_DROP_INFO', value:'Drag and Drop to the Design Section.'}
};